/**
 * @author Akshay Kumar Singh
 * @file SubHeader Component
 * @flow
 */
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

import HeaderComponent from './HeaderComponent';
import ROUTES from "../../../shared/constants/routes";
import { LABLES } from "../../../shared/constants/data";

const SubHeaderComponent = (props) => {
  const history = useHistory();

  const [tab, setTab] = useState(1);
  const [tabName, setTabName] = useState(LABLES.UserManagement)
  const [isShow, setShow] = useState(false);

  /**
   * @description This function is react life cycle hook which sets initial values whenever the component loads.
   */
  useEffect(() => {
    setTab(props.page);
    setTabName(props.pageName);
  }, []);

  /**
   * @description This function switch tabs and render its respective component.
   */
  const switchTab = (event, tab) => {
    event.preventDefault();
    setShow(false);
    switch (tab) {
      case 1:
        history.push(ROUTES.DASHBOARD)
        break;
      case 2:
        history.push(ROUTES.QUESTIONMANAGEMENT)
        break;
      case 3:
        history.push(ROUTES.PLANTMANAGEMENT)
        break;
      case 4:
        history.push(ROUTES.SCORINGMANAGEMENT)
        break;
      default:
    }
  }

  return (
    <React.Fragment>
      <HeaderComponent />
      <nav className="menu">
        <span className="tab-name">{tabName}</span>
        <div className="mobile-menu" onClick={() => setShow(!isShow)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul className={isShow ? 'show-mobile-menu' : ''}>
          <li className={tab === 1 ? "active" : ''}><a href='' onClick={(e) => switchTab(e, 1)}>{LABLES.UserManagement}</a></li>
          <li className={tab === 2 ? "active" : ''}><a href="" onClick={(e) => switchTab(e, 2)}>{LABLES.QuestionManagement}</a></li>
          <li className={tab === 3 ? "active" : ''}><a href="" onClick={(e) => switchTab(e, 3)}>{LABLES.PlantManagement}</a></li>
          <li className={tab === 4 ? "active" : ''}><a href="" onClick={(e) => switchTab(e, 4)}>{LABLES.ScoringManagement}</a></li>
        </ul>
        {tab === 1 &&
          <div className="search-group">
            <input type="search" name='searchedItem' placeholder='Search User...' className="form-control search-control"
              onChange={(event) => props?.setSearchedItem(event.target.value)} disabled={!props?.dataArr?.length} />
            {/* <input type="button" className="search-btn"/> */}
          </div>}
      </nav>
    </React.Fragment>
  )
}

export default SubHeaderComponent;